import { render, staticRenderFns } from "./ServiceNumberPage.vue?vue&type=template&id=8c76f590&scoped=true&"
import script from "./ServiceNumberPage.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c76f590",
  null
  
)

export default component.exports